import { useCallback } from "react";

import Head from "next/head";

type GoogleRecaptchaProps = {
  action: string;
  children({
    getToken,
  }: {
    getToken(action: string): Promise<string>;
  }): React.ReactNode;
};

/**
 * To test in development, find the recaptcha key at
 * https://console.cloud.google.com/security/recaptcha
 * and set it as the GOOGLE_RECAPTCHA_SITE_KEY environment variable in dotcom.
 * Flatbook needs to also have all the necessary enviroment variables set,
 * which can be seen in flatbook's GoogleRecaptchaValidation class.
 */
export function GoogleRecaptcha({ children }: GoogleRecaptchaProps) {
  const recaptchaSiteKey = global.GOOGLE_RECAPTCHA_SITE_KEY;

  const getToken = useCallback(
    (action: string) =>
      recaptchaSiteKey && typeof global.grecaptcha !== "undefined"
        ? global.grecaptcha.enterprise.execute(recaptchaSiteKey, {
            action,
          })
        : Promise.resolve(),
    [recaptchaSiteKey],
  );

  return (
    <>
      <Head>
        <script
          async
          defer
          key="recaptcha"
          src={`https://www.google.com/recaptcha/enterprise.js?render=${recaptchaSiteKey}`}
        ></script>
      </Head>

      {children({ getToken })}
    </>
  );
}
